var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticClass:"custom-overlay-class",attrs:{"value":_vm.$store.state.overlay.show}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }